import React from 'react';
import { Box } from '@mui/material';
import VerticalLoadingScreen from './VerticalLoadingScreen';
import { LOADING_IMAGES, LOADING_MESSAGES } from './utils/hotelLoading.data';

/** Hotel vertical loader — hotel search and results. */
const HotelLoader = ({ active = true, minHeight = '400px' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        minHeight,
        background: 'transparent',
      }}
    >
      <VerticalLoadingScreen
        active={active}
        images={LOADING_IMAGES}
        messages={LOADING_MESSAGES}
      />
    </Box>
  );
};

export default HotelLoader;
